import { checkIfIsXingyuanSkinItem, getSkinOfHero, sortByCharacter } from "../api/gameProps"
import { flatten, groupBy, sortBy } from "lodash"
import { ITEM_TYPES } from "../store/enums"

/**
 * 事件代理,取出目标节点
 * @param target
 * @param datasetId
 * @returns {*}
 */
export function getClosetElementWithAMSID(target, datasetId) {
  while (target) {
    if (target.dataset && target.dataset[datasetId] !== undefined) {
      break
    }

    target = target.parentNode

    if (target?.id === "backpacklist") {
      break
    }
  }

  return target && target.dataset[datasetId]
}

/**
 * 获得背包大区接口大区信息
 * @param userZoneInfo
 */
export function getZoneParams(userZoneInfo) {
  if (userZoneInfo && userZoneInfo.zoneName) {
    const { area, partition, gamePlatformId, roleId } = userZoneInfo

    return {
      area,
      game_platform_id: gamePlatformId,
      partition,
      roleid: roleId
    }
  }

  return {}
}

/**
 * 分页获取背包列表
 * @param orderedPropList
 * @param index
 * @param pageSize
 */
export function getBackListByPageIndex(currentDisplayPropList, index, pageSize = 30) {
  return currentDisplayPropList.slice(pageSize * index, pageSize * (index + 1)).filter(item => item)
}

/**
 * 获得背包列表全部内容信息
 * @param propList
 * @returns {*}
 */
export function getAllVmallGoodsListByCharactor(propList) {
  const heroSortListArray = []

  propList.forEach(props => {
    //   英雄皮肤关系 || 父子关系道具
    if (
      (props && props.itemExtend?.HeroID && props.itemExtend?.ItemType == "10") ||
      (!props.itemExtend?.ParentId && !props.itemExtend?.HeroID)
    ) {
      props.pinyin = props?.goodsExtend?.PinYin || props?.itemExtend?.HeroPinYin || props?.itemExtend?.PinYin || "z"
      const firstLetter = props.pinyin.substr(0, 1).toLowerCase()

      const data = {}

      // 获取道具信息
      data.daoju = [props, ...getSkinOfHero(propList, props)]

      // 有内容则设置这个 letter 的值
      if (data.daoju.length) {
        if (!heroSortListArray[firstLetter]) {
          heroSortListArray[firstLetter] = []
        }

        data.indexName = props.name
        data.itemId = props.itemId
        heroSortListArray[firstLetter].push(data)
      }
    }
  })

  return sortByCharacter(heroSortListArray)
}

/**
 * 根据背包的英雄推荐，展示物品列表
 * @param recommendItemIdList
 * @param propList
 * @param backpackIdList
 * @returns {*}
 */
export function combineRecommendOrder(propList, recommendItemIdList = [], backpackIdList = []) {
  let sortedVmallGoodsList = getAllVmallGoodsListByCharactor(propList)
  let list = flatten(sortedVmallGoodsList.map(item => item.list))

  for (let k = recommendItemIdList.length; k >= 0; k--) {
    let itemId = recommendItemIdList[k]

    for (let i = 0; i < list.length; i++) {
      if (itemId === list[i].itemId) {
        let d = list.splice(i, 1)

        if (d?.length) {
          list.unshift(d[0])
        }
      }
    }
  }

  for (let i = 0; i < list.length; i++) {
    let props = list[i].daoju
    for (let j = 0; j < props?.length; j++) {
      props[j].inbag = backpackIdList.indexOf(props[j].itemId) > -1 ? 1 : 0
    }
  }

  let flattenPropList = flatten(list.map(item => item.daoju))

  // 过滤出非英雄、皮肤的道具
  flattenPropList = flattenPropList.filter(item => [ITEM_TYPES.hero, ITEM_TYPES.skin].indexOf(item?.itemExtend?.ItemType) > -1)

  // 找出按是否在拥有此物品的分类
  let res = groupBy(flattenPropList, item => item.inbag)

  return [...res[1], ...res[0]].filter(item => item)
}

/**
 * 根据道具列表获取道具的种类和个数
 * @param orderedPropList
 * @returns {Dictionary<unknown[]>}
 */
export function countItemtype(orderedPropList) {
  return groupBy(
    orderedPropList.filter(item => item.inbag),
    prop => {
      if (prop.itemExtend?.ItemType === ITEM_TYPES.hero) {
        return "hero"
      } else {
        if (checkIfIsXingyuanSkinItem(prop)) {
          return "xingyuan"
        } else {
          return "skin"
        }
      }
    }
  )
}

/**
 * 通过用户的筛选信息和当前的全部物品列表，获得筛选后的道具
 * @param orderedPropList
 * @param currentFilterStatus
 * @returns {*}
 */
export function getFilterPropsByType(orderedPropList, currentFilterStatus) {
  return orderedPropList.filter(prop => {
    // 按照是否拥有来筛选
    let condition1 = item => item
    switch (currentFilterStatus[0]) {
      case "inbag":
        condition1 = item => {
          return item.inbag === 1
        }
        break

      case "notinbag":
        condition1 = item => {
          return item.inbag !== 1
        }
        break
    }

    // 按照英雄、皮肤、星元皮肤来筛选
    let condition2 = item => item
    switch (currentFilterStatus[1]) {
      case "hero":
        condition2 = item => item.itemExtend.ItemType === ITEM_TYPES.hero
        break

      case "skin":
        condition2 = item => item.itemExtend.ItemType === ITEM_TYPES.skin && !checkIfIsXingyuanSkinItem(item)
        break

      case "xingyuan":
        condition2 = item => item.itemExtend.ItemType === ITEM_TYPES.skin && checkIfIsXingyuanSkinItem(item)
        break
    }

    // 自定义菜单筛选
    let condition3 = item => {
      // 为空代表不筛选
      if (currentFilterStatus[2] === "all") {
        return item
      }

      if (item?.menuInfo?.length) {
        // 获取这个物品的菜单列表
        let menuIdList = item.menuInfo.map(goodsMenu => {
          return goodsMenu.menuId
        })

        // 判断当前菜单的id,是否在菜单列表内
        return menuIdList.indexOf(currentFilterStatus[2]) > -1
      }
      return false
    }

    return condition1(prop) && condition2(prop) && condition3(prop)
  })
}

/**
 * 获得配置的集合列表
 * @param currentItem
 * @returns {[]}
 */
export function getMenuIdList(currentItem) {
  let menuList = []
  if (currentItem?.backpackFilter) {
    let ids = currentItem.backpackFilter.split("&")

    // 需要保证顺序是产品配置的菜单顺序
    for (let i = 0; i < ids.length; i++) {
      let [id, text = ""] = ids[i].split("=")
      let [title = "", desc = ""] = text.split(";")
      menuList.push({
        id,
        text: title,
        desc
      })
    }
  }

  return menuList
}

/**
 * 通过menuId获取道具列表
 */
export function getPropsByMenuId(vmallGoodsList, menuId) {
  return vmallGoodsList.filter(prop => {
    let propMenuList = prop?.menuInfo?.map(goodsMenu => {
      return goodsMenu.menuId
    })

    return propMenuList.indexOf(menuId) > -1
  })
}

/**
 * 根据菜单ID获得对应的内容
 * @param menuId
 * @param propList
 * @param currentItem
 * @param backpackIdList
 * @returns {{list: *}}
 */
export function getInventoryByMenuId(menuId, propList, currentItem, backpackIdList) {
  let menuList = getMenuIdList(currentItem)
  let currentMenu = menuList.filter(item => item.id === menuId)[0] || {}

  let res = {
    ...currentMenu,
    list: propList.map(item => {
      return {
        ...item,
        inbag: backpackIdList?.indexOf(item.itemExtend?.AMSID) > -1 ? 1 : 0
      }
    })
  }

  if (res?.list?.length) {
    res.list = sortBy(res.list, item => item.inbag)
  }

  return res
}

/**
 * 获得集合列表
 * @param vmallGoodsList
 * @param currentItem
 * @param backpackIdList
 */
export function getInventoryList(vmallGoodsList, currentItem, backpackIdList = []) {
  let customMenuIdList = getMenuIdList(currentItem)

  vmallGoodsList.forEach(prop => {
    // 获取这个物品的菜单列表
    if (prop?.menuInfo?.length) {
      let propMenuList = prop.menuInfo.map(goodsMenu => {
        return goodsMenu.menuId
      })

      customMenuIdList.forEach(menu => {
        if (propMenuList.indexOf(menu.id) > -1) {
          if (!menu.list) {
            menu.list = []
          }

          menu.list.push({
            ...prop,
            inbag: backpackIdList?.indexOf(prop.itemId) > -1 ? 1 : 0
          })
        }
      })
    }
  })

  customMenuIdList.forEach(item => {
    if (item?.list?.length) {
      item.list = sortBy(item.list, item => !item.inbag)
    }
  })

  return customMenuIdList
}
